import { Spin } from "antd";
import { useSelector } from "react-redux";

const GlobalLoader = ({ loading }) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const theme = useSelector((state) => state.customise.theme);
  
  return (
    loading && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: theme === 'dark' ? 'rgba(0, 0, 0, 0.2)' : 'rgba(255, 255, 255, 0.2)', 
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000,
          backdropFilter: "blur(1px)",
        }}
      >
        <Spin size="large" />
      </div>
    )
  );
};

export default GlobalLoader;
